import { useQuery, useMutation } from '@tanstack/react-query';
import { useApiClient } from 'utils/apiClient';
import * as N from 'Common/notifications';
import { defineMessage, useIntl } from 'react-intl';
import { useCommonInfo } from 'Common/hooks/info';
import { handleErrorNotification } from 'Common/utils';

// eslint-disable-next-line import/prefer-default-export
export const useAccount = () => {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['account'],
    queryFn: apiClient.CoreApi.fetchAccount,
    staleTime: 1000,
    refetchOnWindowFocus: false,
  });
};

export const useSaveAccount = () => {
  const apiClient = useApiClient();
  const intl = useIntl();
  return useMutation({
    mutationFn: apiClient.CoreApi.saveAccount,
    onSuccess: () => {
      N.publishUIMessage(
        'success',
        defineMessage({
          defaultMessage: 'Settings successfully saved.',
        })
      );
    },
    onError: (error) => {
      handleErrorNotification({
        error,
        lang: intl.locale.toLowerCase(),
      });
    },
  });
};

// DEPRECATED: useRedirectActivePlan and useRedirectUpdatePlan have been removed
// These hooks are no longer needed as we moved to Chargebee

export const useLogout = () => {
  const apiClient = useApiClient();
  return useMutation({
    mutationFn: apiClient.CoreApi.logout,
  });
};

export const useInstantToken = (token?: string) =>
  useCommonInfo(token || undefined);

export const useSubscriptionCreateCheckoutSession = () => {
  const apiClient = useApiClient();
  return useMutation({
    mutationFn: ({
      merchantId,
      redirectUrl,
      locale,
    }: {
      merchantId: string;
      redirectUrl: string;
      locale: string;
    }) =>
      apiClient.Subscription.createCheckoutSession({
        merchantId,
        productFamily: 'shore_pos',
        redirectUrl,
        locale,
      }),
  });
};
